import React, { Fragment } from 'react'
import { Outlet } from 'react-router'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'


const AuthLayout = () => {
    const token = useSelector((state) => state.user?.token)

    if (token) {
        return <Navigate to="/admin/dashboard" replace={true} />
    }

    return (
        <Fragment>
            <Header />
            <Outlet />
            <Footer />
        </Fragment>
    )
}

export default AuthLayout